<div
  #videoDiv
  class="video"
  [ngClass]="{
    'small-width': isSmallWidth(),
    'medium-height': isMediumHeight(),
    'small-height': isSmallHeight(),
    multiple: isMultipleItems(),
    highlight: highlightSearchResult
  }"
  [attr.draggable]="!isMultipleItems()"
  (dragstart)="isMultipleItems() ? false : onDragStart($event)"
  (dragend)="onDragEnd()"
  [title]="formatName() + '\n' + formatVideoHours()"
>
  <div
    class="background"
    [ngStyle]="generateVideoSectionStyle()"
    [ngClass]="{
      'background-live-feed':
        video.mediaId === '' && video.feedId !== '' && video.promoId === '',
      'background-contract': isShowContract(video)
    }"
  ></div>
  <div class="video-details">
    <div class="thumbnail">
      <img *ngIf="!!video.thumbnailUrl" src="{{ video.thumbnailUrl }}" />
    </div>
    <div class="title">
      <div class="video-hours">
        <span
          *ngIf="!!video.feedId"
          class="live-feed-icon"
          inlineSVG="/assets/icons/live-icon.svg"
        ></span>
        <span *ngIf="!!video?.show?.isAnchored" class="anchor-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="10"
            viewBox="0 -960 960 960"
            width="1-"
          >
            <path
              d="M480-80q-61 0-125-22t-116-60q-52-38-85.5-89T120-360v-120l160 120-62 62q29 51 92 88t130 47v-357H320v-80h120v-47q-35-13-57.5-43.5T360-760q0-50 35-85t85-35q50 0 85 35t35 85q0 39-22.5 69.5T520-647v47h120v80H520v357q67-10 130-47t92-88l-62-62 160-120v120q0 58-33.5 109T721-162q-52 38-116 60T480-80Zm0-640q17 0 28.5-11.5T520-760q0-17-11.5-28.5T480-800q-17 0-28.5 11.5T440-760q0 17 11.5 28.5T480-720Z"
            />
          </svg>
        </span>
        {{ formatVideoHours() }}
      </div>
      <span [innerHTML]="formatName()"></span>
    </div>
    <div *ngIf="currentView.daysCount <= 1" class="sec-events-popup-container">
      <div class="sec-event-indicator-icons">
        <span
          class="sec-event-icon"
          [ngClass]="{
            'sec-event-inactive': !secEventTypeExists(
              video.items[0].secEvents,
              secEventType.Audio
            )
          }"
          inlineSVG="/assets/icons/audio-icon.svg"
        ></span>
        <span
          class="sec-event-icon"
          [ngClass]="{
            'sec-event-inactive': !secEventTypeExists(
              video.items[0].secEvents,
              secEventType.Subtitles
            )
          }"
          inlineSVG="/assets/icons/subtitles-icon.svg"
        ></span>
        <span
          class="sec-event-icon"
          [ngClass]="{
            'sec-event-inactive': !secEventTypeExists(
              video.items[0].secEvents,
              secEventType.ClosedCaptions
            )
          }"
          inlineSVG="/assets/icons/closed-captions-icon.svg"
        ></span>
        <span
          class="sec-event-icon"
          [ngClass]="{
            'sec-event-inactive': !secEventTypeExists(
              video.items[0].secEvents,
              secEventType.Autopilot
            )
          }"
          inlineSVG="/assets/icons/autopilot-icon.svg"
        ></span>
        <span
          class="sec-event-icon"
          [ngClass]="{
            'sec-event-inactive': !secEventTypeExists(
              video.items[0].secEvents,
              secEventType.Graphics
            )
          }"
          inlineSVG="/assets/icons/graphics.svg"
        ></span>
        <span
          class="sec-event-icon"
          [ngClass]="{
            'sec-event-inactive': !secEventTypeExists(
              video.items[0].secEvents,
              secEventType.Cuetone
            )
          }"
          inlineSVG="/assets/icons/cuetone.svg"
        ></span>
        <span
          class="sec-event-icon"
          [ngClass]="{
            'sec-event-inactive': !secEventTypeExists(
              video.items[0].secEvents,
              secEventType.SCTE
            )
          }"
          inlineSVG="/assets/icons/SCTE.svg"
        ></span>
        <span
          class="sec-event-icon"
          [ngClass]="{
            'sec-event-inactive': !secEventTypeExists(
              video.items[0].secEvents,
              secEventType.FloatingMedia
            )
          }"
          inlineSVG="/assets/icons/floating-media.svg"
        ></span>
      </div>
      <!-- Uncomment this on P2 --->
      <!--            <pop-over #popup>-->
      <!--                <evrideo-calendar-grid-sec-events-popup class="sec-events-popup" (viewOptionChange)="viewOptionChangeEvent($event, this.video.items[0].id)" [secEvents]="video.items[0].secEvents"></evrideo-calendar-grid-sec-events-popup>-->
      <!--            </pop-over>-->
    </div>
    <div
      class="capsule subtitles"
      [class.active]="subtitlesPopoverVisible"
      *ngIf="video.subtitles.length > 0"
      (click)="onSubtitlesClick($event)"
    >
      <div
        inlineSVG="/assets/icons/subs-icon-capsul.svg"
        class="capsule-icon"
      ></div>
      <span class="capsule-name">Subtitles</span>
      <div class="capsule-count">{{ formatSubtitlesCount() }}</div>
    </div>
  </div>
</div>
<div
  class="duration-adjuster"
  *ngIf="showDurationAdjuster()"
  draggable="true"
  (dragstart)="onDurationAdjusterDragStart($event)"
  (dragend)="onDurationAdjusterDragEnd($event)"
></div>
